import { BsTelephone } from 'react-icons/bs';
import { MdOutlineMail } from 'react-icons/md';

import Button from 'molecules/Button';
import Image from 'molecules/Image';
import RichText from 'molecules/RichText';

import styles from 'components/Leadership/leadership.module.scss';

import type { LeadershipProps } from 'components/Leadership/config';
import type { FC } from 'react';

const Leadership: FC<LeadershipProps> = ({
  type = 'float',
  image,
  heading,
  eyebrow,
  email,
  phoneNumber,
  description,
  backgroundColor = false,
  fullImage = false,
  callToAction,
}) => (
  <div className={styles[type]}>
    <div className={styles.leadership}>
      <div className={`${backgroundColor === true ? styles.gridBackground : styles.backgroundNone}`}>
        <div className={styles.gridWrapper}>
          {image?.url && (
            <div
              className={`${fullImage === true ? styles.fullImageWrapper : styles.imageWrapper} ${styles.gridImage}`}
            >
              <div className={styles.image}>
                <Image {...image} width={image?.width || 1204} height={image?.height || 1204} />
              </div>
            </div>
          )}
          <div className={styles.contentWrapper}>
            <div
              className={`${styles.background} ${
                backgroundColor === false ? styles.backgroundNone : styles.backgroundColor
              }`}
            >
              <div className={styles.container}>
                <div className={styles.display}>{eyebrow && <h2 className={styles.eyebrow}> {eyebrow}</h2>}</div>
                {image?.url && (
                  <div
                    className={`${fullImage === true ? styles.fullImageWrapper : styles.imageWrapper} ${
                      styles.floatImage
                    }`}
                  >
                    <div className={styles.image}>
                      <Image {...image} width={image?.width || 500} height={image?.height || 1000} />
                    </div>
                  </div>
                )}
                <div className={styles.headborder}>
                  {heading && <h1 className={styles.heading}> {heading}</h1>}
                  {eyebrow && <h2 className={styles.eyebrow}> {eyebrow}</h2>}
                </div>
              </div>
            </div>
            {description && (
              <div className={backgroundColor === true ? styles.bodyBackground : ''}>
                <div className={styles.container}>
                  <div className={styles.content}>
                    <div>
                      {email && (
                        <div className={styles.iconBar}>
                          <MdOutlineMail size={16} />
                          <a href={`mailto:${email}`}>{email}</a>
                        </div>
                      )}
                      {phoneNumber && (
                        <div className={styles.iconBar}>
                          <BsTelephone />
                          <p>{phoneNumber}</p>
                        </div>
                      )}
                    </div>
                    <div className={fullImage === false ? styles.addPadding : ''}>
                      <RichText content={description.replace(/\\n/g, '\n')} className={styles.richText} />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {callToAction?.label && (
        <div className={styles.button}>
          <Button {...callToAction} className={styles.leftArrow} textLink="textLink" iconId="arrow-right" />
        </div>
      )}
    </div>
  </div>
);

export default Leadership;
